export default {
  sm: `
  We operate Customer Support Center with 
  technical experts for 24 hours, 365 days to 
  address various customer issues in a rapid 
  and accurate manner. Our experts will help 
  you when you have any inquiries or 
  inconvenience.    
  `,
  md: `
  We operate Customer Support Center with 
  technical experts for 24 hours, 365 days to 
  address various customer issues in a rapid 
  and accurate manner. Our experts will help 
  you when you have any inquiries or 
  inconvenience.    
  `,
  lg: `
  We operate Customer Support Center with technical 
  experts for 24 hours, 365 days to address various 
  customer issues in a rapid and accurate manner. 
  Our experts will help you when you have any inquiries or 
  inconvenience.    
  `,
  xxl: `
  We operate Customer Support Center with
  technical experts for 24 hours, 365 days to 
  address various customer issues in a rapid
  and accurate manner. Our experts will help 
  you when you have any inquiries or
  inconvenience.    
  `,
};
